import { Button } from '@mui/material';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { useRoutes } from 'hooks/useRoutes';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';

interface Props {
  handleClick: VoidFunction;
}

export const CreateNewOpportunityButton = ({ handleClick }: Props) => {
  const { currentRouteConfig } = useRoutes();

  const userProfile = useSelector((state: any) => state.userProfile);

  const opportunitiesPortalConfigurations = useSelector(state =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.Opportunities)
  );
  const voManagementPortalConfigurations = useSelector(state =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.VoManagement)
  );

  const isVisible = useMemo((): boolean => {
    const allowManualVoCreation = opportunitiesPortalConfigurations?.jsonDefinition.config.allowManualVoCreation;
    const disallowVoСreationRoles =
      voManagementPortalConfigurations?.jsonDefinition.config.rolesSettings.disallowVoСreation;

    return (
      currentRouteConfig?.id === 'vo' &&
      allowManualVoCreation &&
      !disallowVoСreationRoles?.includes(userProfile?.vendorContactRole)
    );
  }, [userProfile, currentRouteConfig, voManagementPortalConfigurations, opportunitiesPortalConfigurations]);

  if (!isVisible) return null;

  return (
    <Button color="primary" variant="contained" size="small" onClick={handleClick}>
      Create new opportunity
    </Button>
  );
};
